export const DENTOLO = 'dentolo';
export const PETOLO = 'petolo';
export const VITOLO = 'vitolo';

export const INSURANCE_TYPES = [DENTOLO, PETOLO, VITOLO];
export const DEFAULT_INSURANCE_TYPE = DENTOLO;
